import { AuthUserClient } from '~/app-modules/user/clients/auth-user.client';

@singleton()
export class AuthUserService {
  constructor(protected authUserClient: AuthUserClient) {}

  public getCurrentUser() {
    return this.authUserClient.getCurrentUser();
  }
}
